// extracted by mini-css-extract-plugin
module.exports = {"item":"index_item_3xCLF","icon":"index_icon_1OYdO","title":"index_title_1KI4c","line":"index_line_2wq2D","modalsize":"index_modalsize_2PcQc"};